<template>
  <div class="v-help-form">
    <form class="form" @submit.prevent="newTicket">
      <div class="py-3">
        <textarea v-model="input.description" name="request" rows="10" class="p-3"
                  placeholder='Пожалуйста, опишите вашу проблему как можно подробнее.'>
        </textarea>
      </div>
      <div class="text-muted text-right">
        <p>Время обработки обращения может составлять до 24 часов.</p>
      </div>
      <div class="form-group pt-3">
        <button type="submit" class="btn btn-primary">Отправить</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'v-help-form',
  data() {
    return {
      input: {
        description: '',
      },
    };
  },
  methods: {
    ...mapActions('ticket', ['getTicketList', 'createTicket']),
    close() {
      this.$emit('close');
    },
    newTicket() {
      this.createTicket(this.input)
        .then(() => {
          this.$notify({
            group: 'message',
            title: 'New message:',
            type: 'success',
            text: 'Ваша заявка успешно отправлена!',
          });
        })
        .finally(() => { this.$emit('close'); });
    },
  },
};
</script>
